/* eslint-disable react-hooks/exhaustive-deps */
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { appConstants } from "utils/appConstants";
import React, { useEffect, useState } from "react";
import TimelineItem from "components/Icon/TimelineItem";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import DataTable, { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { showResMsg } from "utils/generic";
import BillingModal from "components/displayModel/billingModel";
import { genericMessage } from "utils/genericMessages";
import { viewQuotationDetails } from "utils/quotationAPI";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import ActivityLog from "layouts/activityLog/activityLog";
import MDTypography from "components/MDTypography";
import { downloadQuotation } from "utils/quotationAPI";
import DownloadIcon from '@mui/icons-material/Download';
import { AllKeysHaveValue } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // increase the width
  height: "90%x", // increase the height
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "#202940",
    },
    context: {
      background: "#202940",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);



function Quotation() {
  let dispatch = useDispatch();
  const { id: QuotationID } = useParams();
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const navigate = useNavigate();

  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "", itemDescription: "", itemPrice: "", itemQuantity: "", categoryCodeName: "", gst: "", discountType: "None", discountValue: ""
    },
  ]);
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');

  const [quoDocuments, setDocuments] = useState([]);
  const [currencyCode, setCurrencyCode] = useState("");
  const [values, setValues] = useState({
    quotationID: undefined,
    quotationNumber: 'Auto Generated',
    contactID: '',
    invoiceID: '',
    purchaseOrderNumber: '',
    quotationDate: new Date(),
    validUpto: "Same Day",
    validUptoDate: new Date(),
    quotationStatus: 'Pending',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
    sendEmailFlag: false,
  })
  console.log(values.contactID)
  //Used for Modal Email Template 
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    selectedID: '',
    screenType: "Quotation",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });
  useEffect(() => {
    setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
    ViewQuotationID();
  }, [dispatch]);

  const handleCreateInvoice = async () => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to create the Invoice with the details of Quotation ${values.quotationNumber}?`, 'warning', darkMode,
      () => {
        dispatch(loadingAction(true));
        let payload = { businessUserID: loginDetails?.businessUserID, quotationID: QuotationID }
        axios.post(appConstants.baseURL + "quotation/createInvoice", payload,
          { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` } }
        ).then(res => {
          dispatch(loadingAction(false));
          let status = res.data.Result_Status;
          if (res.data.Result_Output === "NO AVAILABLE CREDITS") {
            setShowBillingModal(true);
          } else {
            showResMsg(res.data.Result_Message, 2000, status, navigate, status === true ? `/invoices/edit/${res.data.Result_Output._id}` : "");
          }
        }).catch(error => {
          dispatch(loadingAction(false));
          console.log("Error in created Invoices:", error);
        })
      }
    );
  }


  const ViewQuotationID = () => {
    viewQuotationDetails({ quotationID: QuotationID }, (res) => {
      console.log("res", res)
      let data = res.Result_Output[0];
      if (res.Result_Status) {
        setCurrencyCode(data.currencyValue);
        setValues(data);
        data.itemsList.length > 0 && setItemRowValues(data.itemsList);
        data.documentsList.length > 0 && setDocuments(data.documentsList);
      } else {
        setCurrencyCode(data.currencyValue);
        setValues(data);
        // showResMsg(res.Result_Message, 2000, res.Result_Status, navigate, '/quotations');
      }
    }, dispatch)
  }
  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
        minHeight: '30px'
      },
    },
    headCells: {
      style: {
        paddingLeft: "5px",
        paddingRight: "5px",
        fontSize: "12px",
        color: "white",
      },
    },
  };

  let columns = [
    {
      name: "Item Name",
      selector: row => row.itemName,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Description",
      selector: row => row.itemDescription,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "Qty",
      selector: row => row.itemQuantity,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Item Price (${values.currencyValue})`,
      selector: row => row.itemPrice,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Account",
      selector: row => row.categoryCodeName,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "GST(%)",
      selector: row => row.gst,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },

  ];

  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };


  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action",
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          <Grid item mt={-3}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => { handleViewDocument(row) }}
              title="View"
            />
          </Grid>


        </>
      ),
    },
  ];

  const handleDownload = async () => {

    await downloadQuotation({ _id: QuotationID }, async (response) => {

      const pdfContent = response.data;
      const binaryPdfData = atob(pdfContent);

      const arrayBuffer = new ArrayBuffer(binaryPdfData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryPdfData.length; i++) {
        uint8Array[i] = binaryPdfData.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      ShowSwalWithButtons(
        '', `Would you like to download the Quotation?`, 'question', darkMode,
        () => {
          const link = document.createElement('a');
          link.href = url;
          link.download = `quotation_${values.quotationNumber}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      );
    }, dispatch)


  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };
  const handleSend = (templateData) => {
    console.log("templatedata", templateData)
    let payload = {
      selectedID: templateData.selectedID,
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    dispatch(loadingAction(true));

    axios.post(appConstants.baseURL + "quotation/resendEmail", payload).then(res => {
      dispatch(loadingAction(false));
      let status = res.data.Result_Status;
      showResMsg(res.data.Result_Message, 2000, status);
    }).catch(error => {
      dispatch(loadingAction(false));
      console.log("Error in ResendEmail", error);
    })
    values.sendEmailFlag = true;
    values.templateValues = payload;
    console.log("templateData", values.templateValues)
    setOpen(false)
  }

  const handleEmailQuotation = async () => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: values.contactID, selectedID: QuotationID, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
        console.log("dataa", data)
        if (data.Result_Status) {
          setTemplateValues(data.Result_Output);
          setOpen(true);
        } else {
          showResMsg(data.Result_Message, 2000, false);
          setOpen(false);
        }
      }, dispatch);
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">

          <PageTitle screenName="View Quotation" />
          <Grid container px={2} mt={2} spacing={2}>
            {/* Quotation Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Quotation Number"
                variant="outlined"
                disabled
                fullWidth
                value={values.quotationNumber}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Customer"
                variant="outlined"
                disabled
                fullWidth
                value={values.contactName}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth
                value={values.purchaseOrderNumber}
                inputProps={{
                  className: "custom-fieldtext",
                  maxLength: 50
                }}
                InputLabelProps={{ shrink: true }}

                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Quotation Date"
                variant="outlined"
                fullWidth
                value={values.quotationDate}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Valid Up To"
                variant="outlined"
                fullWidth
                value={values.validUpto}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Valid Upto Date"
                variant="outlined"
                fullWidth
                value={values.validUptoDate}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"

                  style={{ height: "35.11px" }}



                  disabled
                  label="Status"
                  value={values.quotationStatus}

                >
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </Grid>

          </Grid>
          <CardContent>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="210px"
              fixedHeader={true}

            />
          </CardContent>
          <Grid container px={2} pt={2} pb={2} spacing={2}>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"

                  style={{ height: "35.11px" }}



                  label="GST Type"
                  value={values.gstType || 'Inclusive'}
                  disabled
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalAmount}
                inputProps={{
                  className: "custom-fieldtext"
                }}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Discount Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalDiscountAmount}
                inputProps={{
                  className: "custom-fieldtext"
                }}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Final Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.finalAmount}
                inputProps={{
                  className: "custom-fieldtext"
                }}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                value={values.paymentInstruction}
                disabled
              />
            </Grid>


          </Grid>
          {/* Doc Table only visible if doc Array have data */}
          {quoDocuments.length > 0 &&
            <CardContent>
              <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={documentColumns}
                data={quoDocuments}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />
            </CardContent>
          }

          <Stack spacing={2} mt={2} pb={3} direction="row" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
            <Button variant="outlined" size="small" style={{ fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", color: '#1ed6c9', borderRadius: "5px", }} onClick={() => { navigate('/quotations') }}>
              Close
            </Button>

            {values.quotationStatus === "Approved" && (<Button variant="outlined" size="small" style={{
              fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", borderRadius: "5px", color: '#1ed6c9'
            }}
              disabled={values.invoiceID}
              onClick={handleCreateInvoice} >
              Create Invoice
            </Button>)}
            <Button variant="outlined" size="small" style={{
              fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", borderRadius: "5px", color: '#1ed6c9'
            }}
              onClick={handleDownload}
            >
              <DownloadIcon sx={{ marginRight: "5px" }} /> Print / Download
            </Button>
            <Button variant="outlined" size="small" style={{
              fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", borderRadius: "5px", color: '#1ed6c9'
            }}
              onClick={handleEmailQuotation}
            >
              Send Email
            </Button>
          </Stack>

        </Card>
      </div >
      <div >
        <Card style={{ marginTop: "20px" }}>
          <ActivityLog name="Quotation" />
        </Card>
      </div>
      {
        viewDocumentInModal && <Modal
          open={viewDocumentInModal}
          onClose={() => setViewDocumentInModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            '& .MuiModal-root': {
              width: '100%',
              height: '100%',
            },
          }}
        >
          <Card sx={pdfStyle}>
            <Box>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
              >
                Quotation Document Viewer
              </Typography>
              <iframe title="Quotation Document Viewer" src={getDocumentFileURL} width="100%" height="650" frameborder="0" allowfullscreen={true}></iframe>

              <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>

                  Close
                </MDButton>
              </Grid>

            </Box>
          </Card>
        </Modal>
      }
      <BillingModal
        open={showBillingModal}
        handleConfirm={() => { Navigate('/subscriptions') }}
        handleCancel={() => { setShowBillingModal(false) }}
        closeModalClick={() => { setShowBillingModal(false) }}
        message={genericMessage.billingMsg}
        title={genericMessage.noCreditAvailableTitle}
      />

      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}
    </DashboardLayout >
  );
}

export default Quotation;
